import React from 'react';

// Renders the contract text the backend sends (the same text its PDF is
// made from). Understands only what the template uses: "# ", "## ",
// "- " bullets, **bold**, blank lines and "---".
const inline = (text) =>
  text.split('**').map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>));

const ContractMarkdown = ({ markdown }) => {
  const out = [];
  let bullets = null;
  const flush = () => {
    if (bullets) out.push(<ul key={`ul${out.length}`} className="my-2 ml-5 list-disc space-y-1">{bullets}</ul>);
    bullets = null;
  };
  markdown.split('\n').forEach((raw, i) => {
    const line = raw.trim();
    if (line.includes('SignatureBlock}}')) {
      flush();
      out.push(<p key={i} className="my-1 text-muted">{line.replace(/\{\{\w+SignatureBlock\}\}/, '________________________')}</p>);
      return;
    }
    if (!line || line === '---') { flush(); return; }
    if (line.startsWith('# ')) { flush(); out.push(<h2 key={i} className="mb-3 mt-1 text-lg font-bold text-primary">{inline(line.slice(2))}</h2>); return; }
    if (line.startsWith('## ')) { flush(); out.push(<h3 key={i} className="mb-1 mt-5 text-sm font-bold text-ink">{inline(line.slice(3))}</h3>); return; }
    if (line.startsWith('- ')) { (bullets = bullets || []).push(<li key={i}>{inline(line.slice(2))}</li>); return; }
    flush();
    out.push(<p key={i} className="my-2">{inline(line)}</p>);
  });
  flush();
  return <div className="text-[13px] leading-relaxed text-ink">{out}</div>;
};

export default ContractMarkdown;
